import { type AnyAction, combineReducers } from 'redux';

import { archiveFontWithId, beginLoadingFonts, storeFonts } from 'js/src/data/fonts/fonts-actions';
import type { ReadonlyFontAsset } from 'js/src/data/fonts/fonts-types';
import PlainJsStoreORM from 'js/src/data/plain-js-store-orm';

export function list(
    state = PlainJsStoreORM.createEmpty<ReadonlyFontAsset, number>().data,
    action: AnyAction,
) {
    if (storeFonts.match(action)) {
        const orm = new PlainJsStoreORM(state);
        action.payload.fontList.forEach((value) => {
            orm.pushItem(value, 'id');
        });
        return orm.data;
    }
    if (archiveFontWithId.match(action)) {
        const orm = new PlainJsStoreORM(state);
        orm.delete([action.payload.fontId]);
        return orm.data;
    }
    return state;
}

export function isLoading(state = false, action: AnyAction) {
    if (beginLoadingFonts.match(action)) {
        return true;
    }
    if (storeFonts.match(action)) {
        return false;
    }
    return state;
}

export const fonts = combineReducers({
    isLoading,
    list,
});

export type FontsState = ReturnType<typeof fonts>;
